import { useDispatch } from "react-redux";
import { addToast } from "../redux/slices/toastSlice";
import type { ToastNotification } from "../redux/slices/toastSlice";

export const useToast = () => {
  const dispatch = useDispatch();

  const showToast = (toast: Omit<ToastNotification, "id" | "read">) => {
    dispatch(addToast(toast));
  };

  const notify = (title: string, message: string, priority: "info" | "warning" | "urgent" = "info") => {
    dispatch(addToast({ title, message, priority }));
  };

  return { showToast, notify };
};

